<template>
  <section class="inventory--part-details animated fadeIn">
    <div class="list-group-item mb-2">
      <b-form-radio-group
        :options="['Yes', 'No', 'N/A']"
        v-model="model.tubeInspection_ImprintedLogo"
      >
        <span class="col-form-label">Imprinted with manufacturer name/logo</span>
      </b-form-radio-group>
      <b-form-radio-group
        :options="['Yes', 'No', 'N/A']"
        v-model="model.tubeInspection_TubeCondition"
      >
        <span class="col-form-label">All tubes same length and good condition</span>
      </b-form-radio-group>
      <b-form-radio-group
        :options="['Yes', 'No', 'N/A']"
        v-model="model.tubeInspection_TubeDirection"
      >
        <span class="col-form-label">All parts oriented in same direction</span>
      </b-form-radio-group>
      <b-form-radio-group :options="['Yes', 'No', 'N/A']" v-model="model.tubeInspection_TubeQty">
        <span class="col-form-label">Quantity of parts in tubes are consistent</span>
      </b-form-radio-group>
      <b-form-radio-group
        :options="['Yes', 'No', 'N/A']"
        v-model="model.tubeInspection_TubeStoppers"
      >
        <span class="col-form-label">Tubes have all same stoppers</span>
      </b-form-radio-group>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import {FIELDS}  from '../../constants'
export default {
  name: 'ideaTubes',
  components: {},
  props: {
    inspectionDetails: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      model: {
        tubeInspection_TubeDirection: this.inspectionDetails[FIELDS.TUBE_INSPECTION__TUBE_DIRECTION] || '',
        tubeInspection_ImprintedLogo: this.inspectionDetails[FIELDS.TUBE_INSPECTION__IMPRINTED_LOGO] || '',
        tubeInspection_TubeCondition: this.inspectionDetails[FIELDS.TUBE_INSPECTION__TUBE_CONDITION] || '',
        tubeInspection_TubeQty: this.inspectionDetails[FIELDS.TUBE_INSPECTION__TUBE_QTY] || '',
        tubeInspection_TubeStoppers: this.inspectionDetails[FIELDS.TUBE_INSPECTION__TUBE_STOPPERS] || '',
      },
    };
  },
  computed: {},
  mounted() {},
};
</script>